import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fillPoliceForm,
  addCellInSubFormsType2,
  editCellInSummayDetailForm,
  deleteCellInSummayDetailForm,
  updateImgStrucAnnexure,
} from "../store/pdfdata/pdfdataSliceNew";

import ColorCode from "./ColorCode";
import AddCellModel from "./AddCellModel";
import ColorCheckFun from "./ColorCheckFunNew";
import DatePickerReact from "./DatePickerReact";
import RecursiveModal from "./RecursiveModalNew";
import SummaryRemarks from "./SummaryRemarksNew";
import NotificationAlert from "./NotificationAlert";
import ConfirmationDialog from "./ConfirmationDialog";
import EditCellTitleModel from "./EditCellTitleModel";
import InfoVerifiedDropDown from "./InfoVerifiedDropDown";

const PoliceVerification = ({ annexure }) => {
  const modelId = "policeVerificationCellTileEdit";

  const dispatch = useDispatch();

  const imgStruc = useSelector(
    (state) => state.pdfdatanew.imgStruc["Police Verification"]
  );
  const FatherName = useSelector(
    (state) => state.pdfdatanew["caseDetails"]["Father Name"]
  );
  const applicantName = useSelector(
    (state) => state.pdfdatanew["Name of Applicant"]
  );
  const bAddToAnnexureTile = useSelector(
    (state) => state.annexureFlag.bAddToAnnexureTile
  );
  const policeVerificationForms = useSelector(
    (state) => state.pdfdatanew.forms["Police Verification"]
  );

  const execSummary = useSelector((state) => state.pdfdatanew.executiveSummary);
  const dob = useSelector((state) => state.pdfdatanew["Date of Birth"]);
  const [selectedCellPosition, setSelectedCellPosition] = useState();
  const [selectedFormNumber, setselectedFormNumber] = useState("");
  const [selectedCellTitle, setSelectedCellTitle] = useState("");
  const [selectedSubForm, setSelectedSubForm] = useState("");
  const [confirmation, setConfirmation] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const addVal = (e, table, form, component) => {
    e.preventDefault();
    dispatch(
      fillPoliceForm([
        "Police Verification",
        table,
        form,
        component,
        e.target.name,
        e.target.value,
      ])
    );
    if (e.target.name === "Status")
      ColorCheckFun(dispatch, execSummary, table, e.target.value);
  };
  const addCell = (typecellref, fieldType, position, mainTable, subTable) => {
    subTable = [subTable]["form2"];
    if (typecellref === "") {
      setNotify({
        isOpen: true,
        message: "Please Enter New Cell Title...",
        type: "warning",
      });
      return;
    }
    if (position === "") {
      setNotify({
        isOpen: true,
        message: "Please Select The Position Where You Want To Add New Cell",
        type: "warning",
      });
      return;
    }
    dispatch(
      addCellInSubFormsType2({
        type: typecellref,
        fieldType,
        position,
        mainTable,
        subTable,
      })
    );
  };

  const onEditCell = (cellTitileRef) => {
    if (cellTitileRef === "") {
      setNotify({
        isOpen: true,
        message: "Please Enter New Cell Title...",
        type: "warning",
      });
      return;
    }
    if (
      selectedSubForm === "" ||
      selectedFormNumber === "" ||
      selectedCellPosition === ""
    ) {
      setNotify({
        isOpen: true,
        message: "Something went wrong!!",
        type: "error",
      });
    }
    const mainTable = "Police Verification";
    dispatch(
      editCellInSummayDetailForm({
        type: cellTitileRef,
        selectedSubForm,
        selectedFormNumber,
        selectedCellPosition,
        mainTable,
      })
    );
    setSelectedCellPosition("");
    setSelectedSubForm("");
    setselectedFormNumber("");
  };
  const onDeleteCell = (index, table, formnumber) => {
    if (index === "" || table === "") {
      setNotify({
        isOpen: true,
        message: "Something went wrong!!",
        type: "error",
      });
    }
    setConfirmation({
      ...confirmation,
      isOpen: false,
    });
    const mainTable = "Police Verification";
    const subform = table;
    const form = formnumber;
    const cellPosition = index;

    dispatch(
      deleteCellInSummayDetailForm({
        subform,
        form,
        cellPosition,
        mainTable,
      })
    );
    setNotify({
      isOpen: true,
      message: "Cell has been deleted!",
      type: "error",
    });
  };

  const addDateVal = (table, form, component, name, value) => {
    dispatch(
      fillPoliceForm([
        "Police Verification",
        table,
        form,
        component,
        name,
        value,
      ])
    );
  };

  useEffect(() => {
    Object.keys(policeVerificationForms).map((table, index) => {
      if (imgStruc && imgStruc[table]) {
        Object.keys(imgStruc[table]).map((img) => {
          if (imgStruc[table][img]["isChecked"] !== undefined) {
            dispatch(
              updateImgStrucAnnexure([
                "Police Verification",
                table,
                img,
                annexure + (index + 1),
              ])
            );
          }
        });
      }
    });

    Object.keys(policeVerificationForms).map((table, index) => {
      dispatch(
        fillPoliceForm([
          "Police Verification",
          table,
          "form2",
          "Annexure Details",
          "Annexure Details",
          `Please refer Annexure-${annexure + (index + 1)}${
            bAddToAnnexureTile[annexure + (index + 1)] ? "" : "-NA"
          }`,
        ])
      );
    });
  }, [bAddToAnnexureTile, annexure]);

  useEffect(() => {
    Object.keys(policeVerificationForms).map((table, index) => {
      dispatch(
        fillPoliceForm([
          "Police Verification",
          table,
          "form1",
          "Name of the Applicant",
          "infoProvided",
          applicantName?.value,
        ])
      );
      dispatch(
        fillPoliceForm([
          "Police Verification",
          table,
          "form1",
          "Date of Birth",
          "infoProvided",
          dob?.value,
        ])
      );
      dispatch(
        fillPoliceForm([
          "Police Verification",
          table,
          "form1",
          "Father Name",
          "infoProvided",
          FatherName?.value
            ? FatherName?.value
            : policeVerificationForms[table]["form1"]["Father Name"]
                .infoProvided,
        ])
      );
    });
  }, [applicantName, dob, FatherName]);

  return (
    <>
      <NotificationAlert notify={notify} setNotify={setNotify} />
      <ConfirmationDialog
        confirmation={confirmation}
        setConfirmation={setConfirmation}
      />

      <h3 className="text-center mt-4">
        <u>Police Verification</u>
      </h3>

      {Object.keys(policeVerificationForms).map((table, index) => (
        <table key={table}>
          <tr>
            <th className="heading" colSpan={3}>
              <div className="row row-cols-2">
                <div className="col">
                  <h3>{table}</h3>
                </div>
              </div>
            </th>
          </tr>
          <tr>
            <th className="centered-text">Components</th>
            <th className="centered-text">Information Provided</th>
            <th className="centered-text">Information Verified</th>
          </tr>

          {Object.keys(policeVerificationForms[table]["form1"]).map(
            (row, index) => (
              <>
                <tr>
                  {row === "Name of the Applicant" ? (
                    <td className="NOA col-sm-6">
                      <div className="row row-cols-2">
                        <div className="col-sm-12">{row}</div>
                      </div>
                    </td>
                  ) : row === "Date of Birth" ? (
                    <td className="DOB col-sm-6">
                      <div className="row row-cols-2">
                        <div className="col-sm-12">{row}</div>
                      </div>
                    </td>
                  ) : row === "Father Name" ? (
                    <td className="FN col-sm-6">
                      <div className="row row-cols-2">
                        <div className="col-sm-12">{row}</div>
                      </div>
                    </td>
                  ) : (
                    <td className="cellTitle col-sm-6">
                      <div className="row row-cols-2">
                        <div className="col-sm-10">{row}</div>
                        <div className="col-sm-1">
                          <button
                            className="editIcon fa fa-pencil"
                            type="button"
                            data-bs-toggle="modal"
                            title="Edit Cell Title"
                            data-bs-target={`#${modelId}`}
                            data-bs-whatever="@mdo"
                            onClick={() => {
                              console.log(row, index);
                              setSelectedCellPosition(index);
                              setSelectedSubForm(table);
                              setselectedFormNumber("form1");
                              setSelectedCellTitle(row);
                            }}
                          ></button>
                        </div>
                        <div className="col-sm-1">
                          {" "}
                          <button
                            className="editIcon fa fa-trash"
                            type="button"
                            title="Delete Cell Title"
                            onClick={(e) => {
                              setConfirmation({
                                isOpen: true,
                                title: "Are you sure to delete this cell?",
                                subTitle: "You can't undo this operation!",
                                onConfirm: () => {
                                  onDeleteCell(index, table, "form1");
                                },
                              });
                            }}
                          ></button>
                        </div>
                      </div>
                    </td>
                  )}

                  {row === "Date of Birth" && dob ? (
                    <td>
                      <DatePickerReact
                        inputTagName={row}
                        val={
                          policeVerificationForms[table]["form1"][row]
                            .infoProvided
                            ? policeVerificationForms[table]["form1"][row]
                                .infoProvided
                            : dob.value
                        }
                        disabled={true}
                      />
                    </td>
                  ) : (
                    <td>
                      {row === "Name of the Applicant" ? (
                        <textarea
                          style={{ width: "100%", height: 30 }}
                          id={`PoliceVerification${table}Applicant`}
                          type="text"
                          disabled={true}
                          defaultValue={
                            policeVerificationForms[table]["form1"][row]
                              .infoProvided !== ""
                              ? policeVerificationForms[table]["form1"][row]
                                  .infoProvided
                              : applicantName.value
                          }
                          name="infoProvided"
                          onChange={(e) => {
                            addVal(e, table, "form1", row);
                          }}
                        />
                      ) : row === "Father Name" ? (
                        <textarea
                          style={{ width: "100%", height: 30 }}
                          id={`PoliceVerification${table}FatherName`}
                          type="text"
                          defaultValue={
                            policeVerificationForms[table]["form1"][row]
                              .infoProvided
                          }
                          name="infoProvided"
                          onChange={(e) => {
                            addVal(e, table, "form1", row);
                          }}
                        />
                      ) : (
                        <textarea
                          style={{ width: "100%", height: 30 }}
                          type="text"
                          value={
                            policeVerificationForms[table]["form1"][row]
                              .infoProvided
                          }
                          name="infoProvided"
                          onChange={(e) => {
                            addVal(e, table, "form1", row);
                          }}
                        />
                      )}
                    </td>
                  )}

                  <td>
                    <InfoVerifiedDropDown
                      fun={(e) => addVal(e, table, "form1", row)}
                      currentValue={
                        policeVerificationForms[table]["form1"][row]
                          .infoVerified
                      }
                    />
                  </td>
                </tr>
              </>
            )
          )}

          {Object.keys(policeVerificationForms[table]["form2"]).map(
            (row, index) => (
              <tr>
                {row === "Status" ? (
                  <td className="Status col-sm-6">
                    <div className="row row-cols-2">
                      <div className="col-sm-12">{row}</div>
                    </div>
                  </td>
                ) : (
                  <td className="cellTitle col-sm-6">
                    <div className="row row-cols-2">
                      <div className="col-sm-10">{row}</div>
                      <div className="col-sm-1">
                        <button
                          className="editIcon fa fa-pencil"
                          type="button"
                          data-bs-toggle="modal"
                          title="Edit Cell Title"
                          data-bs-target={`#${modelId}`}
                          data-bs-whatever="@mdo"
                          onClick={() => {
                            console.log(row, index);
                            setSelectedCellPosition(index);
                            setSelectedSubForm(table);
                            setselectedFormNumber("form2");
                            setSelectedCellTitle(row);
                          }}
                        ></button>
                      </div>
                      <div className="col-sm-1">
                        {" "}
                        <button
                          className="editIcon fa fa-trash"
                          type="button"
                          title="Delete Cell Title"
                          onClick={(e) => {
                            setConfirmation({
                              isOpen: true,
                              title: "Are you sure to delete this cell?",
                              subTitle: "You can't undo this operation!",
                              onConfirm: () => {
                                onDeleteCell(index, table, "form2");
                              },
                            });
                          }}
                        ></button>
                      </div>
                    </div>
                  </td>
                )}

                {row === "Status" ? (
                  <ColorCode
                    namefield={row}
                    cls={policeVerificationForms[table]["form2"][row]}
                    fun={(e) => {
                      addVal(e, table, "form2", row);
                    }}
                    spanNum={2}
                  />
                ) : row.toLocaleLowerCase().search(/\bdate\b/) > -1 ? (
                  <td key={row + table + index} colSpan={2}>
                    <DatePickerReact
                      inputTagName={row}
                      val={policeVerificationForms[table]["form2"][row]}
                      isSubtable={true}
                      fun={(name, value) => {
                        addDateVal(table, "form2", row, name, value);
                      }}
                    />
                  </td>
                ) : (
                  <td key={row + table + index} colSpan={2}>
                    <textarea
                      style={{ width: "100%", height: 30 }}
                      type="text"
                      id={table + row + "ROCUpdate"}
                      defaultValue={
                        policeVerificationForms[table]["form2"][row]
                      }
                      disabled={row === "Annexure Details" ? true : false}
                      name={row}
                      onBlur={(e) => {
                        addVal(e, table, "form2", row);
                      }}
                    />
                  </td>
                )}
              </tr>
            )
          )}
          <tr>
            <td>Upload Document</td>
            <td colSpan={2}>
              <RecursiveModal
                mainTable="Police Verification"
                subTable={table}
                annexure={annexure + (index + 1)}
              />

              <span className="alert">
                Files of format .jpg, .jpeg, .png, .eml are accepted!
              </span>
            </td>
          </tr>
          {/* <SummaryRemarks
            type="Police Verification"
            namefield={table}
            spanNum={2}
          /> */}
          <tr>
            <td colSpan={3}>
              Please Refer{" "}
              <b>
                Annexure-{annexure}
                {index + 1}
              </b>
            </td>
          </tr>
          <AddCellModel
            inputFields={policeVerificationForms[table]["form2"]}
            onaddCell={(typecellref, position, fieldType) =>
              addCell(
                typecellref,
                position,
                fieldType,
                "Police Verification",
                table
              )
            }
            uniqueName={`PoliceVerification${index}`}
          />
          <EditCellTitleModel
            modelId={modelId}
            onEditCell={onEditCell}
            currentTitle={selectedCellTitle}
            setCurrentTitle={setSelectedCellTitle}
          />
        </table>
      ))}
    </>
  );
};
export default PoliceVerification;
